import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import { Button, Card, Table, Spinner, Alert, Container } from 'react-bootstrap';
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx'; 
import Header from '../Header';

const PlanDetails = () => {
  const [plans, setPlan] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const tableRef = useRef(null);

  // Fetch plans data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/getservices`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();  
        console.log(result);
        setPlan(result || []);  
      } catch (error) {
        console.error("Error fetching data:", error); 
        setError(error.message);  
      } finally {
        setLoading(false);  
      }
    };

    fetchData(); 
  }, []);

  // Initialize DataTable after plans data is fetched
  useEffect(() => {
    if (plans.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [plans]);

  // Export data to Excel
  const exportToExcel = () => {
    if (plans.length === 0) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(plans);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "plans");

    XLSX.writeFile(wb, "plans_List.xlsx");
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <>
      <Header />
      <Container fluid className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <h4 className="mb-0">Services Details</h4>
          <Button variant="success" onClick={exportToExcel}>
            <FontAwesomeIcon icon={faDownload} /> Export to Excel
          </Button>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Card>
          <Card.Header>Services List</Card.Header>
          <Card.Body>
            <div className="table-responsive">
              <Table 
                ref={tableRef}
                striped
                bordered
                hover
                responsive
                size="sm"
              >
                <thead>
                  <tr>
                    <th>S.no</th>                
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {plans.length > 0 ? (
                    plans.map((plan, index) => (
                      <tr key={plan.id}>
                        <td>{index + 1}</td>
                        <td>{plan.name || 'N/A'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2">No Services available</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default PlanDetails;
